import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import PageMeta from '@/components/feature/PageMeta';
import { FAQSchema, WebPageSchema, BreadcrumbSchema } from '@/components/feature/SEOSchema';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import RecommendedSites from './components/RecommendedSites';
import CategoryNav from './components/CategoryNav';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import { recommendedSites, categories, featuredArticles, stats, faqs } from '@/mocks/home';

export default function Home() {
  return (
    <>
      <PageMeta
        title="看片网站推荐2025｜高清免费看片网站合集 - 精选优质在线观影平台"
        description="看片网站推荐2025，精选最受欢迎的免费看片网站，涵盖高清电影、热播剧集、综艺纪录片等海量资源。帮你快速找到清晰流畅、无广告干扰的在线观影平台，告别卡顿与低画质烦恼。"
        keywords="看片网站,免费看片网站,高清看片网站,在线看片网站推荐,好用的看片网站,最新看片网站2025,无广告看片网站"
        canonicalUrl="https://moviplexx.github.io/"
        ogTitle="看片网站推荐2025｜高清免费看片网站合集"
        ogDescription="精选最受欢迎的免费看片网站，涵盖高清电影、热播剧集、综艺纪录片等海量资源。"
        ogType="website"
        ogUrl="https://moviplexx.github.io/"
      />

      <WebPageSchema
        title="看片网站推荐2025｜高清免费看片网站合集"
        description="精选最受欢迎的免费看片网站，涵盖高清电影、热播剧集、综艺纪录片等海量资源。"
        url="https://moviplexx.github.io/"
        dateModified="2025-08-12"
      />
      <BreadcrumbSchema
        items={[{ name: '首页', url: 'https://moviplexx.github.io/' }]}
      />
      <FAQSchema questions={faqs} />

      <ScrollToTop />
      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <HeroSection />
          <StatsSection stats={stats} />
          <RecommendedSites sites={recommendedSites} />
          <CategoryNav categories={categories} />
          <FeaturedArticles articles={featuredArticles} />
          <FAQSection faqs={faqs} />
          <CTASection />
        </main>

        <Footer />
      </div>
    </>
  );
}